import script from "./SharebetReciept.vue?vue&type=script&setup=true&lang=js"
export * from "./SharebetReciept.vue?vue&type=script&setup=true&lang=js"

import "./SharebetReciept.vue?vue&type=style&index=0&id=03e9d018&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-03e9d018"]])

export default __exports__